// import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

import accounting from "../accounting";
import admin from "../admin";
import calendar from "./calendar";
import contact from "./contact";
import expense from "./expense";
import general from "./general";
import library from "./library";
import paycheck from "./paycheck";
import project from "./project";
import quote from "./quote";
import sale from "./sale";
import salesLead from "./sales-lead";
import salesTeam from "./sales-team";
import salesTools from "../sales-tools";
import samples from "./samples";
import serviceLead from "./service-lead";
import snaArchive from "./sna-archive";
import transaction from "./transaction";
import vehicle from "./vehicle";
import warehouse from "./warehouse";

export default {
  routes: [
    {
      path: "/",
      component: () => import("layouts/Main"),
      meta: { auth: () => store.getters.isEmployee() },
      children: [
        ...accounting.routes,
        ...admin.routes,
        ...calendar.routes,
        ...contact.routes,
        ...general.routes,
        ...library.routes,
        ...paycheck.routes,
        ...project.routes,
        ...quote.routes,
        ...sale.routes,
        ...salesLead.routes,
        ...salesTeam.routes,
        ...salesTools.routes,
        ...samples.routes,
        ...serviceLead.routes,
        ...snaArchive.routes,
        ...transaction.routes,
        ...vehicle.routes,
        ...warehouse.routes,
      ],
    },
  ],

  dialogs: [
    ...accounting.dialogs,
    ...admin.dialogs,
    ...calendar.dialogs,
    ...contact.dialogs,
    ...expense.dialogs,
    ...general.dialogs,
    ...library.dialogs,
    ...paycheck.dialogs,
    ...project.dialogs,
    ...quote.dialogs,
    ...sale.dialogs,
    ...salesLead.dialogs,
    ...salesTeam.dialogs,
    ...salesTools.dialogs,
    ...samples.dialogs,
    ...serviceLead.dialogs,
    ...snaArchive.dialogs,
    ...transaction.dialogs,
    ...vehicle.dialogs,
    ...warehouse.dialogs,
  ],
};
